import { render, staticRenderFns } from "./EditorWrapper.vue?vue&type=template&id=3b501d71&scoped=true&"
import script from "./EditorWrapper.vue?vue&type=script&lang=ts&"
export * from "./EditorWrapper.vue?vue&type=script&lang=ts&"
import style0 from "./EditorWrapper.vue?vue&type=style&index=0&id=3b501d71&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b501d71",
  null
  
)

export default component.exports